import { Typography, Stack, ListItemIcon, ListItemText, useTheme } from '@hermes/web-components'
import { TypeMenuItem } from '../styles'
import { SearchTypes } from '../../../../providers/SearchProfilesPage/types'
import NextImage from 'next/image'
import { FC } from 'react'

type Props = {
  title: string
  value: SearchTypes
  isFirstItem: boolean
  isLastItem: boolean
  Icon: string
  searchType: SearchTypes
  onClick: () => void
}

const TypeMenuItemBlock: FC<Props> = ({ title, value, isFirstItem, isLastItem, Icon, onClick, searchType }) => {
  const theme = useTheme()

  return (
    <TypeMenuItem value={value} isFirstItem={isFirstItem} isLastItem={isLastItem} onClick={onClick}>
      <Stack direction="row" justifyContent="space-between" p={0.5}>
        <ListItemIcon>
          <NextImage
            src={`/hermes-static/icons/${Icon}.svg`}
            alt=""
            width={22}
            height={22}
            objectFit="none"
            unoptimized
          />
        </ListItemIcon>
        <ListItemText>
          <Typography
            variant="body1"
            textAlign="left"
            sx={{ color: '#11245A', ...(searchType === value ? theme.custom.SearchBar.SelectedMenuItem : {}) }}
          >
            {title}
          </Typography>
        </ListItemText>
      </Stack>
    </TypeMenuItem>
  )
}

export default TypeMenuItemBlock
